import React from 'react';

import { Page } from '../../../payload/payload-types';
import { Gutter } from '@/app/_components/Gutter';
import { CMSLink } from '@/app/_components/Link';
import RichText from '@/app/_components/RichText';

import classes from './index.module.scss';

type Props = Extract<Page['layout'][0], { blockType: 'content' }>;

export const ContentBlock: React.FC<
  Props & {
    id?: string;
  }
> = props => {
  const { columns } = props;

  return (
    <Gutter className={classes.content}>
      <div className={classes.grid}>

      </div>
    </Gutter>
  );
};
